import React from 'react';
import { Field } from 'redux-form';
//import * as Cleave from 'cleave.js/react';
import DatePicker from 'react-datepicker';
import FaCalendar from 'react-icons/lib/fa/calendar';
import styled from 'styled-components';
import { InputGroup } from 'react-bootstrap';
import { ValidationError } from '../StyledComponents/StyledComponents';
import { Cleave } from '../../../../common/form/components/components';
const Icon = styled.div`
  width: 24px;
`;

const DatePickerStyled = styled.div`
  .react-datepicker-popper {
    z-index: 3 !important;
  }

  .date-picker-one-month-container {
    .react-datepicker-popper {
      left: -100px !important; // box position
    }

    .react-datepicker__triangle {
      margin-left: 0 !important; // triangle location
    }
  }

  // Fixing the Header
  .react-datepicker__header__dropdown--select {
    padding-bottom: 0 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
  }

  /*---------------------
Fixing the TimePicker
---------------------*/

  .react-datepicker__header .react-datepicker__header--time {
    font-size: 2em !important;
  }

  .react-datepicker__header--time {
    font-size: 2em !important;
  }

  .react-datepicker__time-list {
    padding: 0 10px !important;
    font-size: 1em;
  }

  .react-datepicker__header--time {
    padding-bottom: 17px !important;
  }
`;

class CalendarIcon extends React.Component {
  render() {
    const { onClick } = this.props;
    return <FaCalendar size={25} onClick={onClick} />;
  }
}

const AlternativeDatePicker = ({ input, placeholder, ...props }) => {
  const handleChange = (date) => {
    input.onChange(
      date instanceof Date ? new Date(date).toLocaleDateString('en-gb') : '',
    );
  };

  return (
    <Icon>
      <DatePicker
        {...input}
        {...props}
        locale="en-gb"
        customInput={<CalendarIcon />}
        placeholder={placeholder}
        dateFormat={'DD/MM/YYYY'}
        //selected={input.value ? moment(input.value, 'DD/MM/YYYY') : null}
        onChange={handleChange}
        disabledKeyboardNavigation={false}
        popperModifiers={{
          offset: {
            enabled: true,
            offset: '-45px, 10px',
          },
        }}
      />
    </Icon>
  );
};

const ErrorMessage = styled.span`
  color: #cf2631;
  font-size: smaller;
`;

const ValidationState = ({ showError, children }) => {
  return <ValidationError showError={showError}>{children}</ValidationError>;
};

export default class PublicDatePicker extends React.PureComponent {
  render() {
    const {
      input: { name },
      meta,
    } = this.props;
    const showError = meta.touched && meta.error;
    return (
      <ValidationState showError={showError}>
        <InputGroup>
          <Field
            name={name}
            placeholder="dd/mm/yyyy"
            cleaveOptions={{ date: true, datePattern: ['d', 'm', 'Y'] }}
            component={Cleave}
          />

          <InputGroup.Addon>
            <DatePickerStyled>
              <Field
                name={name}
                component={AlternativeDatePicker}
                placeholder="dd/mm/yyyy"
              />
            </DatePickerStyled>
          </InputGroup.Addon>
        </InputGroup>
        {showError && <ErrorMessage>{meta.error}</ErrorMessage>}
      </ValidationState>
    );
  }
}
